import { Colors } from "@flatfile/design-system";
import { TooltipContainerStyles } from "../Styles.js";
import styled from "styled-components";
const Container = styled.div`
  ${TooltipContainerStyles}
  min-height: 100%;
  ${(props) => {
  const adjustTop = props.isFirstNonHeaderRow;
  const adjustLeft = props.isFirstColumn;
  if (adjustLeft || adjustTop) {
    return `
        input {
          ${adjustTop ? `
              margin-top: 0px;
              height: 30px;
              padding-top: 0px;` : ""}
          ${adjustLeft ? "padding-left: 7px;" : ""}
        }
      `;
  }
}}
`;
const StyledEditorInput = styled.input`
  font-size: ${(props) => props.theme.baseFontSize};
  font-family: inherit;
  padding: 1px 8px;
  border: none;
  width: 100%;
  height: 31px;
  box-shadow: 0 1px 0 0 ${Colors.Pigeon200};

  &:focus {
    outline: none;
  }
`;
const DatePickerWrapper = styled.div`
  padding: 4px 3px;
  background: ${(props) => props.theme.backgroundColor};
`;
export {
  Container,
  DatePickerWrapper,
  StyledEditorInput
};
